/**
 * Copied & adjusted from https://gist.github.com/hugo-cardoso/7c8da4f55d521a6288fc7a0f7d2ff06c
 * Custom composable to imitate what the @u3u/vue-hooks vuex hooks were doing.
 * Temporary wrappers to keep the vue-hooks vuex workflows with Vue 2.7 and Vuex 3.
 * Cannot be used outside of Vue components! Will only find the store inside the current component.
 *
 * @deprecated This will be removed and vuex will be replaced by pinia at some point.
 * If pinia is already set up, please use pinia for new stores or refactor your store to pinia.
 *
 * @todo
 * - Next steps should be:
 *   - Add pinia (maybe vuex 3 and pinia in parallel in the beginning)
 *   - Rewrite vuex stores to pinia stores and use those
 *   - Once all vuex stores are gone, remove vuex
 *   - Hopefully use pinia stores as they are when upgrading to vue 3
 */

import { getCurrentInstance, computed } from 'vue';

/**
 * @deprecated This will be replaced by pinia at some point.
 * Use if necessary, but if pinia is already added to the project, please try to refactor your stores to pinia.
 */
export const useStore = () => {
    const $store = getCurrentInstance().proxy.$store;

    return computed(() => $store);
};

/**
 * @deprecated This will be replaced by pinia at some point.
 * Use if necessary, but if pinia is already added to the project, please try to refactor your stores to pinia.
 */
export const useState = (...args: [string[]] | [string, Record<string, string>]) => {
    const $store = getCurrentInstance().proxy.$store;

    if (args.length === 2) {
        const namespace = args[0];
        const stateMappings = args[1];

        return Object.entries(stateMappings).reduce((states, [newKey, key]) => {
            return {
                ...states,
                [newKey]: computed(() => $store.state[namespace][key]),
            };
        }, {});
    }

    const stateKeys = args[0];

    return stateKeys.reduce((states, key) => {
        return {
            ...states,
            [key]: computed(() => $store.state[key]),
        };
    }, {});
};

/**
 * @deprecated This will be replaced by pinia at some point.
 * Use if necessary, but if pinia is already added to the project, please try to refactor your stores to pinia.
 */
export const useGetters = (...args: [string[]] | [string, string[]]) => {
    const $store = getCurrentInstance().proxy.$store;

    const getterKeys = args.length === 2 ? args[1] : args[0];

    return getterKeys.reduce((getters, key) => {
        const getterName = args.length === 2 ? `${ args[0] }/${ key }` : key;

        return {
            ...getters,
            [key]: computed(() => $store.getters[getterName]),
        };
    }, {});
};

/**
 * @deprecated This will be replaced by pinia at some point.
 * Use if necessary, but if pinia is already added to the project, please try to refactor your stores to pinia.
 */
export const useMutations = (...args: [string[]] | [string, string[]]) => {
    const $store = getCurrentInstance().proxy.$store;

    const mutationKeys = args.length === 2 ? args[1] : args[0];

    return mutationKeys.reduce((mutations, key) => {
        const mutationName = args.length === 2 ? `${ args[0] }/${ key }` : key;

        return {
            ...mutations,
            [key]: (...args: unknown[]) => $store.commit(mutationName, ...args),
        };
    }, {});
};

/**
 * @deprecated This will be replaced by pinia at some point.
 * Use if necessary, but if pinia is already added to the project, please try to refactor your stores to pinia.
 */
export const useActions = (...args: [string[]] | [string, string[]]) => {
    const $store = getCurrentInstance().proxy.$store;

    const actionKeys = args.length === 2 ? args[1] : args[0];

    return actionKeys.reduce((actions, key) => {
        const actionName = args.length === 2 ? `${ args[0] }/${ key }` : key;

        return {
            ...actions,
            [key]: (...args: unknown[]) => $store.dispatch(actionName, ...args),
        };
    }, {});
};
